import {
  ActivityBookingStatus,
  type ActivityReservation,
} from "@b2bportal/rbc-activities-api";
import { useI18nContext } from "@hopper-b2b/i18n";
import dayjs from "dayjs";
import { formatDateWithWeekday } from "@/utilities/formatDate";

export const useActivityReservationCard = (
  reservation: ActivityReservation
) => {
  const { t, formatDateTime } = useI18nContext();
  // Some reservations come back from activities-api with no activityDetails at
  // all, which rendered a card with no name. "tripCardTitle" is the generic
  // "Activity" label.
  const title =
    reservation.activityDetails?.name ??
    t("activities.postBooking.tripCardTitle");
  const dateString = reservation.activitySelection?.travelDate ?? "";
  const date = dateString
    ? formatDateWithWeekday(dayjs(dateString).toDate(), formatDateTime)
    : "";
  const confirmationCode = reservation.customerReservationId ?? "";
  const image = reservation.activityDetails?.coverImage;
  const city = reservation.activityDetails?.destination ?? "";
  const activityStatus =
    reservation.activityStatus || ActivityBookingStatus.Unknown;

  const isPastTrip = dateString ? new Date(dateString) < new Date() : false;
  const isCancelled = activityStatus === ActivityBookingStatus.Cancelled;
  return {
    text: { title, date, confirmationCode, city },
    context: { image, activityStatus, isPastTrip, isCancelled },
  };
};
